import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  IconButton,
  Button,
  Paper,
} from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Empty from "../emptypage/emptyCart";
import { RiSubtractFill, RiSubtractLine } from "react-icons/ri";
import { IoAddOutline } from "react-icons/io5";
import { GrFormClose } from "react-icons/gr";
import TopPageImage from "../../components/toppageimage";
// import ButtonForAll from '../components/ButtonForALL';
import {
  ImageUrl,
  deleteApiCall,
  deleteFromcartApi,
  getApiCall,
  getcartApi,
  getdeliverycharge,
  postApiCall,
  quantitydecApi,
  quantityincApi,
} from "../../API/baseUrl";
import ToastMessage from "../../utils/ToastMessage";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import Loader from "../../components/loader";
import emptycartlist from "../../Assect/cartempt.jpg";
import ButtonComponent from "../../components/button";
import ButtonForAll from "../../components/ButtonForALL";
import { WidthFull } from "@mui/icons-material";
import { IoMdAdd } from "react-icons/io";

const CartForMobile = ({ reload, setReload }) => {
  const navigate = useNavigate();
  const user_id = localStorage.getItem("user_id");
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [pending, setPending] = React.useState(false);
  const [price, setPrice] = React.useState("");
  const [deliveryCharge, setDeliveryCharge] = React.useState("");
  const [deliverychargevalue, setDeliverychargevalue] = React.useState("");

  const [discount, setDiscount] = React.useState("");
  const [totalPrice, setTotalPrice] = React.useState("");
  // console.log(deliveryCharge,"deliveryChargedeliveryCharge");
  const handlegetdeliverycharge = async () => {
    try {
      const result = await getApiCall(getdeliverycharge);
      if (result.data.status) {
        setDeliverychargevalue(result.data.data.cart_value);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    handlegetdeliverycharge();
  }, []);
  // Function to fetch cart data
  const getCart = async () => {
    setPending(true);
    try {
      const result = await getApiCall(`${getcartApi}/${user_id}`);
      if (result?.data?.status) {
        setData(result?.data?.productDetails);
        setPrice(result?.data?.cartTotalPrice);
        setDeliveryCharge(result?.data?.deliveryCharges);
        setDiscount(result?.data?.discount);
        setTotalPrice(result?.data?.totalCartValue);
      } else {
        ToastMessage("error", result.data.message);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setPending(false);
    }
  };

  // Function to refresh cart data
  const refreshCart = async () => {
    try {
      const result = await getApiCall(`${getcartApi}/${user_id}`);
      if (result?.data?.status) {
        setData(result?.data?.productDetails);
        setPrice(result?.data?.cartTotalPrice);
        setDeliveryCharge(result?.data?.deliveryCharges);
        setDiscount(result?.data?.discount);
        setTotalPrice(result?.data?.totalCartValue);
      } else {
        ToastMessage("error", result.data.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getCart();
  }, []);

  // Function to handle increment quantity
  const handlePlus = async (id, index) => {
    // alert("Dd")
    try {
      const result = await postApiCall(quantityincApi, {
        id: id,
        userId: user_id,
      });
      refreshCart();
      if (result?.data?.status) {
        setLoading(true);
        setLoading(false);
        data[index].quantity = data[index].quantity + 1;
        setData([...data]);
        setReload(!reload);
        refreshCart();
      } else {
        ToastMessage("error", result.data.message);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  // Function to handle decrement quantity
  const handleMinus = async (id, quantity, index) => {
    if (quantity === 1) {
      // Handle if quantity is 1
    } else {
      setLoading(true);
      try {
        const result = await postApiCall(quantitydecApi, {
          id: id,
          userId: user_id,
        });
        if (result?.data?.status) {
          setLoading(false);
          data[index].quantity = data[index].quantity - 1;
          setData([...data]);
          refreshCart();
          setReload(!reload);
        } else {
          ToastMessage("error", result.data.message);
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoading(false);
      }
    }
  };

  // Function to navigate to product details page
  const goToDetails = (id, name) => {
    navigate(`/productDetails/${id}/${name}`);
  };

  // Function to delete item from cart
  const deleteFromCartAlert = (id) => {
    swal({
      title: "Are you sure you want to delete?",
      text: "Once deleted, you won't be able to revert this!",
      icon: "warning",
      buttons: {
        cancel: "Cancel",

        confirm: {
          text: "Delete",
          value: true,
          className: "custom-ok-button",
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteFromCart(id);
      }
    });
  };

  // Function to delete item from cart
  const deleteFromCart = async (id) => {
    try {
      const result = await deleteApiCall(
        `${deleteFromcartApi}/${user_id}/${id}`
      );
      if (result?.data?.status) {
        ToastMessage("success", result.data.message);
        const updatedData = data.filter((item) => item.productId !== id);
        setData(updatedData);
        refreshCart();
        setReload(!reload);
      } else {
        ToastMessage("error", result.data.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  // Function to navigate to checkout page
  const moveToCheckout = () => {
    const outOfStockProducts = data?.filter((item) => item.is_in_stock === 0);
    if (outOfStockProducts.length) {
      ToastMessage(
        "error",
        "Please remove out of stock products from the cart to proceed."
      );
    } else {
      navigate("/checkout");
    }
  };

  return (
    <>
      <div>
        {pending ? (
          <Loader />
        ) : (
          <div
            className="newcart_container"
            style={{
              marginTop: "20px",
            }}
          >
            {data.length ? (
              <div className="">
                <Box sx={{ pt: 1 }}>
                  {data.map((product, index) => (
                    <Paper
                      key={index}
                      elevation={3}
                      sx={{
                        display: "flex",
                        mb: 2,
                        p: 2,
                        borderRadius: 3,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      }}
                    >
                      <Box
                        component="img"
                        src={`${ImageUrl}${product.files}`}
                        alt="Product"
                        sx={{
                          width: 100,
                          height: 100,
                          borderRadius: 2,
                          cursor: "pointer",
                          objectFit: "cover",
                          mr: 2,
                          transition: "transform 0.3s",
                          "&:hover": { transform: "scale(1.05)" },
                        }}
                        onClick={() =>
                          goToDetails(product.productId, product.product_name)
                        }
                      />

                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={8}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              cursor: "pointer",
                              color: "black",
                              fontWeight: 600,
                              "&:hover": {
                                textDecoration: "underline",
                                color: "var(--primary-color)",
                              },
                            }}
                            onClick={() =>
                              goToDetails(
                                product.productId,
                                product.product_name
                              )
                            }
                          >
                            {product.product_name}
                          </Typography>

                          {product.product_size !== "FreeSize" && (
                            <Typography variant="body2">
                              Size: {product.product_size}
                            </Typography>
                          )}

                          {product.color_name !== "FreeColor" && (
                            <Typography
                              variant="body2"
                              sx={{ textAlign: "left" }}
                            >
                              Color: {product.color_name}
                            </Typography>
                          )}
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <Box
                            display="flex"
                            justifyContent="start"
                            alignItems="center"
                            mb={1}
                          >
                            <Typography sx={{ fontWeight: 500 }}>
                              Price:
                            </Typography>
                            <Typography
                              color="var(--primary-color)"
                              fontWeight={600}
                            >
                              <CurrencyRupeeIcon
                                sx={{ fontSize: 16, verticalAlign: "middle" }}
                              />
                              {product.discount_percent === 0
                                ? product.mrp_amount
                                : product.discount_amount}
                            </Typography>
                          </Box>

                          {product.is_in_stock === 0 ||
                          product.is_active === 0 ? (
                            <Typography color="error" fontWeight={600}>
                              Out Of Stock
                            </Typography>
                          ) : (
                            <Box display="flex" alignItems="center" gap={1}>
                              <IconButton
                                onClick={() =>
                                  handleMinus(
                                    product.id,
                                    product.quantity,
                                    index
                                  )
                                }
                                disabled={loading}
                              >
                                <RiSubtractFill />
                              </IconButton>
                              <input
                                type="number"
                                value={product.quantity}
                                style={{
                                  width: 40,
                                  textAlign: "center",
                                  border: "1px solid #ccc",
                                  borderRadius: 4,
                                }}
                                readOnly
                              />
                              <IconButton
                                onClick={() => handlePlus(product.id, index)}
                              >
                                <IoMdAdd />
                              </IconButton>
                            </Box>
                          )}

                          <Box mt={1} display={"flex"}>
                            <Typography sx={{ fontWeight: 500 }}>
                              Total:
                            </Typography>
                            <Typography
                              color="var(--primary-color)"
                              fontWeight={600}
                            >
                              <CurrencyRupeeIcon
                                sx={{ fontSize: 16, verticalAlign: "middle" }}
                              />
                              {product.discount_percent === 0
                                ? product.mrp_amount * product.quantity
                                : product.discount_amount * product.quantity}
                            </Typography>
                          </Box>

                          <Box mt={1}>
                            <Button
                              variant="outlined"
                              color="error"
                              size="small"
                              onClick={() => deleteFromCartAlert(product.id)}
                              startIcon={<GrFormClose />}
                            >
                              Remove
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </Paper>
                  ))}
                </Box>

                <div className="total2">
                  <h2>Cart Totals</h2>
                  <div className="tablecart2">
                    <ul className="tableul">
                      <li className="totalList">
                        <span className="listText">Subtotal</span>
                        <span className="listValue">
                          <CurrencyRupeeIcon sx={{ fontSize: "18px" }} />{" "}
                          {Number(totalPrice).toFixed(2)}
                        </span>
                      </li>
                      <li className="totalList">
                        <span className="listText">Discount</span>
                        <span className="listvalue">
                          <CurrencyRupeeIcon sx={{ fontSize: "16px" }} />
                          {discount ? Number(discount).toFixed(2) : "0.00"}
                        </span>
                      </li>
                      <li className="totalList">
                        <span className="listText">Total</span>
                        <span className="listValue">
                          <CurrencyRupeeIcon sx={{ fontSize: "18px" }} />{" "}
                          {Number(totalPrice - totalPrice * 0.1).toFixed(2)}
                        </span>
                      </li>
                    </ul>
                  </div>
                  <button
                    className="custom-checkout-button"
                    name="PROCEED To CEHCKOUT"
                    data-aos="fade-up"
                    type="submit"
                    onClick={moveToCheckout}
                    style={{ WidthFull, marginTop: "20px" }}
                  >
                    PROCEED To CEHCKOUT
                    <div className="innercontainer">PROCEED To CEHCKOUT</div>
                  </button>
                  {deliverychargevalue === price ||
                  deliverychargevalue > price ? (
                    <p className="addmore_text justify-center  my-4">
                      <span className="addmore_text">
                        * Add more products worth
                      </span>
                      <span className="addmore_rs d-flex">
                        {" "}
                        <CurrencyRupeeIcon
                          sx={{ fontSize: "18px", display: "flex" }}
                        />{" "}
                        {Number(deliverychargevalue - price).toFixed(2)}
                      </span>{" "}
                      <span style={{ marginLeft: "3px" }}>
                        {" "}
                        to avail Free Delivery
                      </span>
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ) : (
              <Empty image={emptycartlist} btn="Shop Now" />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default CartForMobile;
